import React from "react";
import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {useGlobal} from "reactn";
import {rgba} from "polished";
import {Button, ButtonText} from "Buttons";
import {H3} from "BaseComponents/Text";
import {BlockLink} from "BaseComponents/Link";
import {GetTextColor} from "Helpers/ColorHelper";

export const QuotationBlock = ({
                                   Text,
                                   Heading,
                                   BackgroundImage,
                                   Icon,
                                   ButtonText: BtnText,
                                   ButtonLink,
                                   BackgroundColor
                               }) => {

    const [theme] = useGlobal("theme");
    let bgColorExist = !!BackgroundColor;
    let bgColor = BackgroundColor ? `#${BackgroundColor}` : theme.colors.bg3;
    const {textColor} = GetTextColor(bgColor);
    
    return (
        <QuotationWrapper bgImage={BackgroundImage} bgColor={!bgColorExist ? undefined : bgColor}>
            <Content>
                {Heading && (
                    <H3
                        marginsmall="1.5rem 0 0rem 0"
                        margin="0 0 1rem 0"
                        color={textColor}
                    >
                        {Heading}
                    </H3>
                )}

                <QuoteWrapper>
                    <Quote color={textColor}>{Text}</Quote>
                </QuoteWrapper>
                {ButtonLink.length > 0 && BtnText.length > 0 && (
                    <QuoteButtonWrapper>
                        <BlockLink
                            href={ButtonLink}
                            color={textColor}
                            text={BtnText}
                        />
                    </QuoteButtonWrapper>
                )}
            </Content>
            {Icon !== undefined && (
                <QuoteIconWrapper>
                    <QuoteIcon bgImage={Icon}/>
                </QuoteIconWrapper>
            )}
        </QuotationWrapper>
    );
};

const QuotationWrapper = styled.div.attrs(
    ({overlayColor, theme, bgImage, bgColor}) => ({
        overlay: overlayColor ? `#${overlayColor}` : theme.colors.bg3,
        percent: bgImage ? "50%" : "100%",
        bgColor: bgColor ? `${bgColor}` : undefined
    })
)`
    background: ${({bgImage, overlay, percent, bgColor}) =>
            bgColor ? bgColor : bgImage ? `linear-gradient(to right, ${overlay} ${percent}, rgba(246, 148, 39, 0.9) 100%), url(${bgImage})` : overlay};
    display: flex;
    align-items: center;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 16rem;
    padding: 60px 30px;
    margin: 1rem 0;

    ${media.lessThan(breakpoints.mobile)`
        padding: 4rem 1rem;
		flex-direction: column-reverse;
		align-items: flex-start;


    `}
`;

const Content = styled.div`
    width: 100%;
    max-width: 866px;
    margin: 0 auto;
`;

const QuoteButtonWrapper = styled.div`
    display: flex;

    ${media.lessThan(breakpoints.mobile)`
        max-width: 300px;

    `}
`;

const QuoteWrapper = styled.div`
    display: flex;
    align-items: end;

    ${media.lessThan(breakpoints.mobile)`
        flex-direction: column-reverse;
        align-items: center;
    `}
`;
const Quote = styled.p`
    color: ${({theme, color}) => (color ? color : theme.colors.white)};
    font-family: ${({theme}) => theme.font};
    font-size: 16px;
    line-height: 24px;
    max-width: 715px;
    margin: 0 3rem 0 0;

    ${media.lessThan(breakpoints.mobile)`
        font-size: 20px;
        margin: 1rem 0 0 0;
    `}
`;

const QuoteIconWrapper = styled.div``;

const QuoteIcon = styled.div`
    min-height: 160px;
    min-width: 160px;
    border-radius: 50%;
    min-height: 160px;
    min-width: 160px;
    background-image: ${({bgImage}) => (bgImage ? `url(${bgImage})` : "")};
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`;
